import React, { useState } from 'react'
import { useSelector } from 'react-redux'

import './styles.scss'
import { apiInchat } from 'api'
import EmojiSelector from 'components/EmojiSelector'
import { getStaticImage } from 'utils/statics'
import { getEmoji } from 'utils/getEmoji'

const MessageReactions = props => {
  const {
    conversationId,
    messageId,
    reactions,
    showNumberReactions,
    showEmoji = true,
    showSelector = true,
    isDark = false,
    onPressSelect,
    isChat = true,
    isNotOperator,
    isThread
  } = props
  const { user: operator, inchat } = useSelector(store => store)
  const [isOpenReactionsModal, setIsOpenReactionsModal] = useState(false)
  const conversationMessages = isThread ? inchat?.threads[conversationId]?.messages : inchat?.conversations[conversationId]?.chat?.messages
  const messageIndex = conversationMessages?.findIndex(({ _id }) => _id === messageId)
  const messageReactions = isChat ? conversationMessages?.[messageIndex]?.reactions : reactions

  const toggleReactionsModal = () => setIsOpenReactionsModal(prevState => !prevState)

  const handleSelectReaction = async (reactionType) => {
    const reactionIndex = messageReactions?.findIndex(({ type }) => type === reactionType)
    const reaction = messageReactions?.[reactionIndex]
    if (isOpenReactionsModal) toggleReactionsModal()
    if (reaction?.users?.some(userId => userId === operator._id)) {
      await apiInchat.removeMessageReaction({ conversationId, messageId, reactionType })
    } else {
      await apiInchat.addMessageReaction({ conversationId, messageId, reactionType })
    }
    if (typeof onPressSelect === 'function') onPressSelect()
  }

  return (
    <div className='inchat-message-reactions'>
      {showEmoji ? reactions?.map((it, index) => {
        const emoji = getEmoji(it.type)
        const emojiCount = it.users?.length || 0
        if (emoji) {
          return (
            <button
              key={index}
              className={`
                inchat-message-reactions__reaction-btn
                ${it.users?.some(userId => userId === operator._id) ? 'inchat-message-reactions__reaction-btn--active' : ''}
              `}
              onClick={() => handleSelectReaction(it.type)}
            >
              <span>{emoji}</span>
              {emojiCount && showNumberReactions ? <strong>{emojiCount}</strong> : null}
            </button>
          )
        }
        return null
      }) : null}
      {showSelector &&
        <button className='inchat-message-reactions__btn-icon' onClick={toggleReactionsModal}>
          <figure>
            <img src={getStaticImage(`/icons/orange-brand/icon-emoji-${isDark ? 'dark' : 'grey'}.svg`)} alt='Reaction' />
          </figure>
        </button>
      }

      {/* Reactions modal */}
      <EmojiSelector
        position={!isNotOperator ? 'left' : 'right'}
        showEmojis={isOpenReactionsModal}
        handleToggle={toggleReactionsModal}
        handleSelect={({ id }) => handleSelectReaction(id)}
      />
    </div>
  )
}

export default MessageReactions
